// #737: /settings/notifications?tab=deliveries
//
// Der Parameter statt eines reinen Komponentenzustands, damit ein verlinkter oder neu geladener
// Support-Fall im richtigen Tab aufgeht.
//
// Anders als NOTIFICATIONS_TAB_QUERY_PARAM (#736) schreibt ein Tabwechsel hier die URL: dort waehlt
// das Segment einen Ausschnitt DERSELBEN Liste, hier wechselt man zwischen zwei verschiedenen
// Werkzeugen. Ebenfalls anders als PROFILE_TAB_QUERY_PARAM (#735) ist dieser Parameter KEIN
// Server-Vertrag — /settings/notifications kommt in keiner der fest verdrahteten Mail-Routen vor.

export type DiagnosticsTab = 'messages' | 'deliveries';

/** Der Name des Query-Parameters. */
export const DIAGNOSTICS_TAB_QUERY_PARAM = 'tab';

/**
 * Uebersetzt den Query-Parameter in einen Tab.
 *
 * Ausgewertet wird ausschliesslich der exakte Wert „deliveries". Alles andere — ein anderer Name,
 * abweichende Gross-/Kleinschreibung, ein Zahlwert oder ein fehlender Parameter — landet auf den
 * Nachrichten. Ein unbekannter Wert ist damit nie ein Fehlerfall.
 */
export function diagnosticsTabFor(value: string | null | undefined): DiagnosticsTab {
  return value === 'deliveries' ? 'deliveries' : 'messages';
}

/** Panel-Reihenfolge in notification-diagnostics-page.component.html: 0 = Nachrichten. */
export function diagnosticsTabIndex(tab: DiagnosticsTab): number {
  return tab === 'deliveries' ? 1 : 0;
}

export function diagnosticsTabForIndex(index: number): DiagnosticsTab {
  return index === 1 ? 'deliveries' : 'messages';
}

/**
 * Der Wert fuer die URL. `null` heisst bei router.navigate mit queryParamsHandling 'merge':
 * Parameter entfernen — der Standard-Tab braucht keinen.
 */
export function diagnosticsTabQueryValue(tab: DiagnosticsTab): string | null {
  return tab === 'deliveries' ? 'deliveries' : null;
}
